import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summary-address-field',
  templateUrl: './summary-address-field.component.html',
  styleUrls: ['./summary-address-field.component.scss']
})
export class SummaryAddressFieldComponent {

  @Input() element: any;

  getCustomLabel(value: any) {
    return `${this.element.label} - ${value.typeLabel.name}`;
  }

  getSelectedCountry(value: any) {
    return value.countries.find((country: any) => country.selected && country.name !== 'Select Country')?.name;
  }

  getSelectedState(value: any) {
    return value.states.find((state: any) => state.selected && state.name !== 'Select State/Province')?.name;
  }
}
